import createAudioContext from 'audio-context'
import enableCustomConnects from 'custom-audio-node-connect'

const context = createAudioContext()
enableCustomConnects(context, node => node.input || node)

export default context
